<template>
  <v-footer
    v-if="isLoggedIn && user.employeeType !== 'Genikos Diaxeiristis'"
    app
    class="px-4 py-2 text-body-2 font-weight-medium d-flex align-center justify-space-between"
  >
    <div class="d-flex flex-wrap text-truncate align-center">
      <div class="d-inline-block">
        <v-icon class="mr-2">mdi-account</v-icon>
        <b class="mr-4">{{ user.name }} ({{ user.username }})</b>
      </div>

      <div class="d-inline-block">
        <span class="font-weight-light"> Τύπος Χρήστη: </span>
        <b class="ml-2">{{ getEmployeeTypeText }}</b>
      </div>
    </div>

    <div>
      {{ selectedTap.courtHouse }}
      <v-icon :color="selectedTap.online ? 'success' : 'error'" size="x-small" class="mx-2">
        mdi-circle
      </v-icon>
    </div>

    <v-dialog v-model="selectedTapOfflineErrorDialog" persistent max-width="500px">
      <v-card>
        <v-sheet class="text-h6 px-5 py-2 d-flex align-center">
          Προειδοποίηση
          <v-spacer />
          <v-btn
            variant="plain"
            size="x-small"
            icon="mdi-close"
            @click="selectedTapOfflineErrorDialog = false"
          />
        </v-sheet>

        <v-divider />

        <v-card-text> Το επιλεγμένο Τ.Α.Π. αποσυνδέθηκε! </v-card-text>

        <v-card-actions>
          <v-btn
            variant="flat"
            class="text-capitalize"
            color="blue-darken-3"
            @click="selectedTapOfflineErrorDialog = false"
          >
            Οκ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-footer>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useTapStore } from '@/stores/tap'
import { storeToRefs } from 'pinia'

const authStore = useAuthStore()

const user = computed(() => authStore.user)
const isLoggedIn = computed(() => authStore.isLoggedIn)

const getEmployeeTypeText = computed(() => {
  if (user.value.employeeType === 'Grammateas') {
    return 'Γραμματέας'
  } else if (user.value.employeeType === 'Apoixografitis') {
    return 'Αποηχογραφητής'
  } else if (user.value.employeeType === 'Dikastis') {
    return 'Δικαστής'
  }
  return 'Διαχειριστής'
})

const tapStore = useTapStore()
const selectedTap = computed(() => tapStore.selectedTap)
const { selectedTapOfflineErrorDialog } = storeToRefs(tapStore)
</script>
